'use client';
import { useTranslations } from 'next-intl';
import type React from 'react';

import GlassSegmentedControl from '@cineamo/composables/src/ticket-booking/GlassSegmentedControl';
import type { SeatMapViewMode } from '@cineamo/composables/src/ticket-booking/seat-map-view-mode';

/** The map views, plus the seat list that replaces the map for keyboard and screen-reader users. */
export type SeatPickerView = SeatMapViewMode | 'list';

const LABEL_KEYS: Record<SeatPickerView, string> = {
    '2D': 'seat-map-view-2d',
    '3D': 'seat-map-view-3d',
    list: 'seat-map-view-list'
};

const SeatMapViewToggle: React.FC<{
    view: SeatPickerView;
    canUse3D: boolean;
    onChange: (view: SeatPickerView) => void;
    className?: string;
}> = ({ view, canUse3D, onChange, className }) => {
    const t = useTranslations('tickets');
    const views: SeatPickerView[] = canUse3D ? ['2D', '3D', 'list'] : ['2D', 'list'];
    return (
        <GlassSegmentedControl
            options={views.map((v) => ({
                value: v,
                label: t(LABEL_KEYS[v]),
                ariaLabel: v === 'list' ? t('seat-map-view-list-label') : undefined
            }))}
            value={view}
            onChange={onChange}
            label={t('seat-map-view-label')}
            caption={t('seat-map-view-caption')}
            className={className}
        />
    );
};

export default SeatMapViewToggle;
